<template>
  <div class="history_wrap" :style="preEventToggle ? 'visibility: hidden;' : ''">
    <div class="history">
      <div class="history_items_wrap scr_wrap" v-if="recentSendMessageList.length > 0">
        <swiper class="history_items swiper-wrapper" :options="swiperOption2" ref="rcsMsgList">
          <swiper-slide class="history_item swiper-slide" v-for="(message, index) in recentSendMessageList" :key="index">
            <div class="history_cont" @click="handleClickSlide(index)">
              <div class="txt_wrap" :class="{img_wrap: message.reqProduct === 'MMS'}">
                <img v-if="message.reqProduct === 'MMS'" :src="`/api/v1/fo/preview/${message.legacyFiles.split(',')[0]}`" style="width: 100%; height: 100%; object-fit: cover" alt="" />
                <p v-if="message.reqProduct === 'SMS' || message.reqProduct === 'LMS'" class="stxt" v-html="sanitizeContent(message.content)"></p>
              </div>
            </div>
            <div class="history_desc" @click="handleClickSlide(index)">
              <div class="history_txt">
                <p class="date">{{ message.regDt }}</p>
              </div>
              <div class="type" :class="message.reqProduct"></div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="btn_wrap" v-if="recentSendMessageList.length > 0">
        <button class="btn_up swiper-button-next"></button>
        <button class="btn_down swiper-button-prev"></button>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { eventBus } from "@/modules/commonUtil/service/eventBus";
import confirm from "@/modules/commonUtil/service/confirm";
import DOMPurify from 'dompurify';

export default {
  name: "RecentMessageList",
  components: { swiper, swiperSlide },
  props: {
    preEventToggle: Boolean,
    modiAuth: {
      type: Boolean,
      default: true,
    },
    recentSendMessageList: Array,
  },
  computed: {
  },
  mounted() {
  },
  data() {
    return {
      // 미리보기 화면 swiper
      swiperOption2: {
        slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
        slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
        //freeMode: true, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
        centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
        loop: false,
        direction: "vertical",
        slidesPerView: 3,
        spaceBetween: 12,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".swiper-button-prev",
          prevEl: ".swiper-button-next",
        }
      },
    };
  },
  methods: {
    sanitizeContent(content) {
      return DOMPurify.sanitize(
        content.replace(/(?:\r\n|\r|\n)/g, "<br />"),
        {
          ALLOWED_TAGS: ["br"],
        }
      );
    },
    handleClickSlide(index) {
      eventBus.$on("callbackEventBus", () => {
        this.fnSendData(index);
      });
      confirm.fnConfirm("", "최근 작성문자로 기존 내용에 덮어 씌워집니다. <br/>계속 진행하시겠습니까?", "confirm");
    },
    fnSendData(index) {
      this.$emit("recentSendMessageList", this.recentSendMessageList[index]);
    },
  },
};
</script>
